<template>
  <component
    :is="wrapperComponent"
    v-if="wrapperComponent && value"
    v-tooltipable
    class="truncate"
  >
    <span class="truncate">
      {{ value }}
    </span>
  </component>
  <div v-else-if="value" v-tooltipable class="truncate">{{ value }}</div>
</template>
<script setup lang="ts">
import type { Component } from "vue";

const { value = "" } = defineProps<{
  value?: string;
  wrapperComponent?: Component;
}>();
</script>
